import { split, replace } from "lodash";

// Carefull. This function was probably supposed to work like Perl regex subtitution but
// it's not that at all.
export function getValueByOutputRegex(value, outputRegex) {
    let retVal = value;

    if (outputRegex !== "") {
        const regexSplit = split(outputRegex, '/');
        const pattern = regexSplit[1];

        if (regexSplit[0] === "s") {
            const replacement = regexSplit[2];
            const flag = regexSplit[3];
            const regExp = new RegExp(pattern, flag);
            retVal = replace(value, regExp, replacement);
        }
        else {
            const retMatches = value.match(new RegExp(pattern, regexSplit[3]));
            if(retMatches.length > 0)
                retVal = retMatches[0];
        }
    }

    return retVal;
}


